/* eslint-disable no-console */
import {formatIndian} from '../../../utils/formatIndian';

import {TF} from './../../../constants/Common';

const sumValue = (array: any[]): number => {
  if (array?.length > 0) {
    return array?.reduce((accumulator, currentValue) => {
      const valueToAdd = currentValue?.value || 0; // Treat falsy values as 0

      return accumulator + valueToAdd;
    }, 0);
  } else {
    return 0;
  }
};

export const sumOfTimeFrames = (
  arrayOfObjects: any,
  type: string,
  isCost: boolean = false
): string => {
  let unit = '';
  const value = formatIndian(
    arrayOfObjects?.reduce((total: any, obj: any) => {
      const typeADataArrays = obj?.[TF]?.filter(
        (timeObj: any) => timeObj.type === type
      ).map((timeObj: any) => {
        unit = timeObj.unit;

        return timeObj.data;
      });

      const flattenedTypeAData: any = [].concat(...typeADataArrays);
      const sum = flattenedTypeAData.reduce(
        (acc: number, item: any) => acc + item.value,
        0
      );

      return total + sum;
    }, 0)
  );

  return isCost ? `${unit} ${value}` : `${value} ${unit}`;
};

export default sumValue;
